<div id="main-content" class="content" [attr.data-environment]="envName">
    <app-header
            (mayEditTextComponentEvent)="textComponentEvent($event)"
            [sidenav]="sidenav"></app-header>

    <mat-sidenav-container>

        <mat-sidenav #sidenav mode="over" position="end" class="app-sidenav">
            <app-header-menu [disableCheckEditText]="true"></app-header-menu>
        </mat-sidenav>

        <main>
            <div id="main-router-outlet" class="row">
                <div class="small-12 columns primary-outlet">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </main>

    </mat-sidenav-container>

    <app-footer></app-footer>
</div>